export default () => ({
  services: ['gtm', 'googleMaps', 'autouncle'],
  allowedServices: []
})
